export default function loanPartsAvailableForList(compositeLoanPart) {
  return compositeLoanPart.loanPart.units - compositeLoanPart.listingsContext.offeredLoanPartUnits > 0
}
